// Client
export const LOCALE = navigator.language || 'en-GB';

// eslint-disable-next-line no-shadow
export enum ZoomLevels { // default-zoom
  OutermostMobile = 2,
  InsetMobile = 2.3,
  OutermostDesktop = 3,
  Middle = 4,
  Hawaii = 4.7,
  Innermost = 5,
}
